<template lang="pug">
  .flex.relative
    .rounded-full.w-8.h-8.mr-4.bg-indigo-5.flex.justify-center.items-center(class="lg:hidden")
      p.font-bold.text-white {{index + 1}}
    
    .flex-grow(v-if="company")
      .flex.justify-between.items-cente
        h2.text-2xl.text-gray-9.mb-2 {{objective.title}}
        .relative
          eva-icon.icon.cursor-pointer.text-gray-5(name="more-horizotnal" @click="showObjDropdown = true")
          
          .absolute.right-0.top-0(v-if="showObjDropdown")
            .fixed.top-0.right-0.w-screen.h-screen.blur-bg-sm.z-10(@click="showObjDropdown = false")
            .relative.bg-white.p-2.shadow-xl.mt-8.rounded-lg.z-10.font-semibold.w-32
              .py-1.px-2.rounded-lg.my-1.cursor-pointer(class="hover:bg-gray-1" @click="showObjDropdown = false, showObjModal = true") Edit
              .py-1.px-2.rounded-lg.my-1.cursor-pointer(v-if="!objective.archived" class="hover:bg-gray-1" @click="archiveObj") Archive
              .py-1.px-2.rounded-lg.my-1.cursor-pointer(v-else class="hover:bg-gray-1" @click="unArchiveObj") Un-archive

      KeyResultListItem(v-for="keyResult in keyResults" :key="keyResult.id" :keyResult="keyResult" v-if="keyResult.parent == objective.id")
        
      .createKr.card.outlined.flex.items-center.active(@click="showKrModal = true")
        .rounded-full.w-8.h-8.mr-4.bg-gray-5.flex.justify-center.items-center
          eva-icon.icon.text-white(name="plus")
        
        div
          h3.text-gray-7 Create a Key Result
          p.text-sm.text-gray-6.font-normal Create measurable goals for your objective
      
      Modal(v-if="showKrModal" @close="showKrModal = false")
        CreateKeyResult(:parentId="objective.id" @close="showKrModal = false")
    
    Modal(v-if="showObjModal" @close="showObjModal = false")
      form.card.max-w-sm.w-full(class="sm:rounded-b-none sm:rounded-t-xl sm:p-8" @submit.prevent="saveObj")
        label Objective title
        input(v-focus v-model="objective.title")
        button.main.mt-2(type="submit") Save
    
    .blur-bg-sm.whiter.absolute.top-0.right-0.bottom-0.left-0.flex.items-center.justify-center.-m-1(v-if="loading")
      eva-icon.icon.spin.text-gray-6(name="loader-outline")
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "../templates/Modal";
import CreateKeyResult from "./CreateKeyResult";
import KeyResultListItem from "./KeyResultListItem";

export default {
  props: ["objective", "index"],
  components: { CreateKeyResult, Modal, KeyResultListItem },
  data() {
    return {
      showKrModal: false,
      showObjModal: false,
      showObjDropdown: false,
      krModal: "KeyResult",
      loading: false
    };
  },
  methods: {
    saveObj() {
      this.loading = true;
      this.showObjModal = false;
      this.$store
        .dispatch("updateDoc", {
          collection: "objectives",
          id: this.objective.id,
          item: { title: this.objective.title }
        })
        .then(() =>
          this.$store.dispatch("getObjectives", this.profile.companyId)
        )
        .then(() => {
          this.loading = false;
          return this.$store.dispatch("fireNotification", {
            title: "Saved your objective",
            type: "success"
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    archiveObj() {
      this.loading = true;
      this.showObjDropdown = false;
      this.$store
        .dispatch("updateDoc", {
          collection: "objectives",
          id: this.objective.id,
          item: { archived: true }
        })
        .then(() =>
          this.$store.dispatch("getObjectives", this.profile.companyId)
        )
        .then(() => {
          this.loading = false;
          return this.$store.dispatch("fireNotification", {
            title: "Archived the objective",
            message:
              "You’ll find archived objectives at the bottom of the page",
            type: "success"
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    unArchiveObj() {
      this.loading = true;
      this.showObjDropdown = false;
      this.$store
        .dispatch("updateDoc", {
          collection: "objectives",
          id: this.objective.id,
          item: { archived: false }
        })
        .then(() =>
          this.$store.dispatch("getObjectives", this.profile.companyId)
        )
        .then(() => {
          this.loading = false;
          return this.$store.dispatch("fireNotification", {
            title: "Restored the objective",
            type: "success"
          });
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    ...mapGetters(["company", "keyResults", "profile"])
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      }
    }
  }
};
</script>

<style lang="sass" scoped></style>
